import { useState } from 'react';
import { useUploadHistory } from './CJWManageHistory.hooks';
import CJWManageHistoryTable from '../../shared/CJWManageHistoryTable/CJWManageHistoryTable';
import classes from './CJWManageHistory.module.css';

const CJWManageHistory = () => {
    const [mode, setMode] = useState("APG_ASG");
    const { uploadHistory, loading } = useUploadHistory(mode === "DI");

    const handleModeChange = (event, newMode) => {
        if (newMode !== null) {
            setMode(newMode);
        }
    };

    return (
        <div className={classes.body}>
            <div className={classes.heading}>CJW MANAGE HISTORY</div>
            <div className={classes.fileuploadHistory}>
                <CJWManageHistoryTable
                    uploadHistory={uploadHistory}
                    isPaginationRequired={true}
                    loading={loading}
                    isDIMode={mode === "DI"}
                    mode={mode}
                    onModeChange={handleModeChange}
                />
            </div>
        </div>
    )
}

export default CJWManageHistory;